import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=2639140e&"
import script from "./Activities.controller.js?vue&type=script&lang=js&"
export * from "./Activities.controller.js?vue&type=script&lang=js&"
import style0 from "./Activities.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports